import styled from "styled-components"

const Details = styled.details`
  margin-bottom: 0px;
`

export default Details
